import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IProps {
  show: boolean;
  handleClose: () => void;
  handleDeleteId: () => void;
  name?: string;
}

const DeleteModal = ({ show, handleClose, handleDeleteId, name }: IProps) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      {show && (
        <Modal
          show={show}
          onHide={handleClose}
          centered
          backdrop="static"
          keyboard={true}
          enforceFocus={false}
        >
          <Modal.Header
            closeButton
            style={{ borderBottom: "none" }}
          ></Modal.Header>
          <Modal.Body>
            <div className="mt-2 text-center">
              <i className="ti ti-trash fs-1 text-danger"></i>
              <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                <h5>{t("general.areYouSure")}</h5>
                <p className="text-muted mx-4 mb-0">
                  {t("general.confirmDelete", { name })}
                </p>
              </div>
            </div>
            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <Button
                type="button"
                variant="light"
                className="btn w-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  handleClose();
                }}
              >
                {t("button.cancel")}
              </Button>
              <Button
                type="submit"
                variant="danger"
                className="btn w-sm"
                id="remove-cartproduct"
                onClick={handleDeleteId}
              >
                {t("button.delete")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default DeleteModal;
